module.exports = __webpack_public_path__ + "static/media/addButton.041cdd99.png";